<template>
  <div>
    <v-btn color="white" class="white--text" text x-small @click="confirm=true">Reset</v-btn>

    <v-dialog v-model="confirm" persistent max-width="600">
      <v-card>
        <v-card-title>Reset</v-card-title>
        <v-divider/>
        <v-card-text class="pt-4 body-1">
          Are you sure you want to reset all your data?
          <div class="mt-4 font-weight-bold error--text">
            <v-icon color="error" large>mdi-alert</v-icon>
            This action cannot be undone and will result in all your alcohol (spirits and wine),
            equipment (stills, tanks and fermenters),
            inventory (items, products, casks and bulk containers), and
            operations (mashing, distilliing, bottling, blending, inventory receipts and shipping)
            being permanently deleted.
            <div v-if="$store.getters.company.connectedToAccounting" class="mt-4">
              QuickBooks Online data is NOT reset.
              You will need to manually delete journal entries and other transactions
              or create compensating journal entries.
            </div>
          </div>
          <v-checkbox v-model="ok" label="I confirm I want to reset all data"/>
        </v-card-text>
        <v-divider/>
        <v-card-actions class="pr-6">
          <v-spacer></v-spacer>
          <v-btn color="error" plain @click="reset" :disabled="!ok" :loading="saving">Reset</v-btn>
          <v-btn color="primary" @click="confirm=false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'SettingsReset',
  data() {
    return {
      confirm: false,
      ok: false,
      saving: false
    }
  },
  watch: {
    confirm() {
      if (this.confirm)
        this.ok = false;
    }
  },
  methods: {
    async reset() {
      if (this.ok) {
        this.saving = true;

        // Reset setup complete flag
        const input = this.$store.getters.company.settings;
        input.doneSetup = false;

        const results = await this.$apiCall(`mutation SettingsReset($input:CompanySettingsInput!) {
                                                companySettingsSet(input:$input) {id}
                                                companyClearData {id}
                                              }`,
                                            {input});
        this.saving = false;
        if (!results.error) {
          this.confirm = false;
          this.$router.go();
        }
      }
    }
  }
}
</script>